import { isNil } from '@/utils/checks'
import { TAXONOMY_ROUTES } from '@/domain/term/constants'
type RelatedCenterTermData = {
  type?: string
  slug: string
  title?: string
}
export const getRelatedCenterTermLink = (
  relatedCenterTermData: RelatedCenterTermData
): string | undefined => {
  if (!relatedCenterTermData) {
    return undefined
  }

  if (
    relatedCenterTermData?.type &&
    relatedCenterTermData?.slug &&
    !isNil(TAXONOMY_ROUTES[relatedCenterTermData.type])
  ) {
    return `/${TAXONOMY_ROUTES[relatedCenterTermData.type]}/${
      relatedCenterTermData.slug
    }/`
  }
  if (relatedCenterTermData?.slug) {
    return `/${relatedCenterTermData.slug}/`
  }
  return undefined
}
